<template>
    <div class="freeze-dialog">
        <el-dialog
            :visible.sync="visible"
            :title="$t('Contract.freeze')" left>
            <div class="freeze-dialog-content">
                <div class="freeze-dialog-clientinfo">
                    <div class="freeze-item flex">
                        <div class="single-item">
                            {{ $t('Common.name') }}：{{ clientInfo.clientName }}
                        </div>
                        <div class="single-item">
                            {{ $t('Common.phone') }}：{{ clientInfo.clientPhone }}
                        </div>
                    </div>
                    <div class="freeze-item flex">
                        <div class="single-item">
                            {{ $t('Contract.number') }}：{{ clientInfo.contractNum }}
                        </div>
                        <div class="single-item">
                            {{ $t('Contract.card_name') }}：{{ clientInfo.cardName }}
                        </div>
                    </div>
                    <div class="freeze-item flex">
                        <div class="double-item">
                            {{ $t('Contract.start_end_date') }}：{{ clientInfo.startAt }} ~ {{ clientInfo.endAt }}
                        </div>
                    </div>
                    <div class="freeze-item flex">
                        <div class="single-item">
                            {{ $t('Sell.standard_amount') }}：{{ clientInfo.baseAmt }}
                        </div>
                        <div class="single-item">
                            {{ $t('Member.saler') }}：{{ clientInfo.contractSalesStaffNickname }}
                        </div>
                    </div>
                    <div class="freeze-item flex">
                        <div class="double-item">
                            {{ $t('Sell.Charge.paid_amount') }}：{{ clientInfo.paidAmt }}
                        </div>
                    </div>
                </div>
            </div>
            <el-form class="freeze-dialog-content"
                ref="form"
                :model="form"
                :rules="rules"
                label-suffix=":"
                label-width="120px"
                label-position="right">
                <div style="width: 82%">
                    <el-form-item :label="$t('Card.stop_date')" prop="date">
                        <el-date-picker
                            v-if="step === 1"
                            style="width: 100%"
                            v-model="form.date"
                            type="daterange"
                            :range-separator="$t('Reception.Third.zhi')"
                            value-format="yyyy-MM-dd"
                            :start-placeholder="$t('Common.start_time')"
                            :end-placeholder="$t('Common.end_time')">
                        </el-date-picker>
                        <span v-if="step === 2 && form.date && form.date.length">
                            {{ `${form.date[0]} 00:00:00 ${$t('Reception.Third.zhi')} ${form.date[1]} 23:59:59` }}
                        </span>
                    </el-form-item>
                    <el-form-item :label="$t('Sell.Pay.fee')">
                        <el-input
                            v-if="step === 1"
                            :placeholder="$t('Fill.freeze_fee')"
                            v-model="form.money">
                        </el-input>
                        <span v-if="step === 2">{{ form.money }}</span>
                    </el-form-item>
                    <el-form-item :label="$t('Common.remark')">
                        <el-input
                            v-if="step === 1"
                            :rows="6"
                            type="textarea"
                            v-model="form.remark"
                            :placeholder="$t('Common.remark_placeholder')"></el-input>
                        <span v-if="step === 2">{{ form.remark }}</span>
                    </el-form-item>
                </div>
            </el-form>
            <div class="flex items-top" v-if="step === 2">
                <div style="width: 120px;">{{ $t('Sell.Pay.title') }}</div>
                <div class="freeze-dialog-radio">
                    <el-radio
                        v-for="(item, index) in options"
                        v-model="form.payMethodCode"
                        :label="Number(item.code)"
                        :key="index">
                        {{ item.name }}
                    </el-radio>
                </div>
            </div>
            <div class="text-center">
                <el-button
                    @click="submit"
                    type="primary">
                    {{ step === 1 ? $t('Common.next_step') : $t('Common.carry_out') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Dialog, DatePicker, Radio, RadioGroup } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadio: Radio,
        ElRadioGroup: RadioGroup,
    },
    props: ['activeName'],
    data() {
        return {
            visible: false,
            contractNum: null,
            clientInfo: {},
            form: {
                startAt: null,
                endAt: null,
                money: null,
                remark: null,
                payMethodCode: 1, // 1-现金,2-刷卡,3-银行转账,4-支付宝(门店),5-微信(门店),8-其他
                date: null, // 时间
            },
            rules: {
                date: { required: true, message: this.$t('Choose.stop_card') },
            },
            options: [
                {
                    code: 1,
                    name: this.$t('Sell.Pay.cash'),
                }, {
                    code: 2,
                    name: this.$t('Sell.Pay.swipe'),
                }, {
                    code: 3,
                    name: this.$t('Sell.Pay.bank'),
                }, {
                    code: 4,
                    name: this.$t('Sell.Pay.alipay'),
                }, {
                    code: 5,
                    name: this.$t('Sell.Pay.wechat'),
                }, {
                    code: 8,
                    name: this.$t('Sell.Pay.other'),
                },
            ],
            step: 1,
            getUrl: null,
            postUrl: null,
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    methods: {
        resetForm() {
            this.form = {
                startAt: null,
                endAt: null,
                money: null,
                remark: null,
                payMethodCode: 1,
                date: null,
            };
            this.step = 1;
            setTimeout(() => {
                this.$refs.form.resetFields();
            }, 0);
        },
        filterTime(date) {
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            const hour = date.getHours();
            let minutes = date.getMinutes();
            if (month < 10) month = `0${month}`;
            if (day < 10) day = `0${day}`;
            if (minutes < 10) minutes = `0${minutes}`;

            return `${year}-${month}-${day}`;
        },
        open(data) {
            this.visible = true;
            this.contractNum = data.contractNum;
            this.getDesc();
            this.fetchData();
        },
        getDesc() {
            if (this.activeName === 'member') {
                this.postUrl = `contract/mshp/${this.contractNum}/freeze`;
                this.getUrl = `contract/mshp/${this.contractNum}`;
            }
            else {
                this.postUrl = `contract/coach/${this.contractNum}/freeze`;
                this.getUrl = `contract/coach/${this.contractNum}`;
            }
        },
        fetchData() {
            API.get(this.getUrl).then(res => {
                this.clientInfo = res;
            });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                if (this.step === 1 && !this.form.money) this.postData();
                else if (this.step === 1 && this.form.money) this.step = 2;
                else if (this.step === 2) this.postData();
            });
        },
        postData() {
            const form = Object.assign({}, this.form);
            form.startAt = form.date[0];
            form.endAt = form.date[1];
            delete form.date;
            if (this.step === 1) delete form.payMethodCode;
            API.post(this.postUrl, form).then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.visible = false;
                this.$emit('fetchData');
            });
        },
    },
};
</script>
<style lang="scss">
.freeze-dialog {
    .el-dialog {
        width: 710px;
    }
}
.freeze-dialog-content {
    width: 100%;
    border: 1px solid #e6e6e6;
    padding: 10px;
    margin-bottom: 30px;
    &:last-child {
        margin-bottom: 15px;
    }
}
.freeze-dialog-clientinfo {
    width: 70%;
}
.freeze-item {
    font-size: 12px;
    width: 100%;
    .single-item {
        width: 50%;
    }
    .double-item {
        width: 100%;
    }
    div {
        margin-bottom: 14px;
    }
    &:last-child {
        div {
            margin-bottom: 0;
        }
    }
}
.freeze-dialog-radio {
    .el-radio {
        display: block;
        margin-left: 0 !important;
        margin-bottom: 35px;
    }
}
</style>
